import React, { useState, useEffect, useContext } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
	Request,
	catchErrorHandle,
	CTX_STATE,
	CTX_DISPATCH,
	creator,
	logOut,
	openBrowser,
	checkLogin,
	sysMsg,
	setOnProcessGame,
	getOnProcessGame,
	exitGame,
	refreshUserInfo,
} from "./common";
import "./styles/scss/Home.scss";
import useControl from "./hooks/useControl";
import Login from "./components/Login";
import SearchBox from "./components/SearchBox";
import BeforeClose from "./components/BeforeClose";
import MemberPay from "./components/MemberPay";
import StartStep from "./components/StartStep";
import SelectTime from "./components/SelectTime";
import CodeConvert from "./components/CodeConvert";
import ActShadow from "./components/ActShadow";
import UpdateProcess from "./components/UpdateProcess";
import Kf from "./components/Kf";
import ActModal from "./components/ActModal";
import logo from "./styles/scss/img/home/logo.png";
import barLogo from "./styles/scss/img/home/bar-logo.png";
import crown from "./styles/scss/img/home/crown.png";
import qqKfIcon from "./styles/scss/img/home/qq-kf-icon.png";

const NavList = [
	{
		key: 1,
		name: "共享游戏",
		to: "Store",
	},
	{
		key: 2,
		name: "独享游戏",
		to: "Wjyz",
	},
	{
		key: 3,
		name: "我的游戏",
		to: "Personal/0",
	},
];

export default function App() {
	const _state = useContext(CTX_STATE);
	const _dispatch = useContext(CTX_DISPATCH);
	const navigate = useNavigate();
	const location = useLocation();

	const [menuIsShow, setMenuIsShow] = useState(false);
	const [canBack, setCanBack] = useState(false);
	const [closeTips, setCloseTips] = useState(undefined);
	const [beforeCloseIsShow, setBeforeCloseIsShow] = useState(false);
	const { orderAndStart } = useControl();

	const memberTime = _state.userInfo?.totalMinutes;

	//网吧版兼容
	const isNetbar = window.mbQuery?.appInfo?.type === "netbar";

	useEffect(() => {
		if (beforeCloseIsShow) return;

		const getData = async () => {
			//获取用户关闭提示
			try {
				const res = await window.mbQuery?.getCloseTips?.();
				setCloseTips(res);
			} catch (error) {}
		};

		getData();
	}, [beforeCloseIsShow]);

	useEffect(() => {
		if (location.key === "default") {
			setCanBack(false);
		} else {
			setCanBack(true);
		}
	}, [location]);

	const loginClose = () => {
		_dispatch(creator("setLoginIsShow", false));
	};

	const memberPayClose = () => {
		_dispatch(creator("setMemberPayIsShow", false));
		refreshUserInfo(_state.token, _state.userInfo, _dispatch);
	};

	const beforeCloseClose = () => {
		setBeforeCloseIsShow(false);
	};

	const selectTimeClose = () => {
		_dispatch(
			creator("setSelectTimeIsShow", {
				isShow: false,
			})
		);
	};

	const selectTimeOk = async (hours) => {
		try {
			_dispatch(
				creator("setSelectTimeIsShow", {
					isShow: false,
				})
			);

			_dispatch(creator("setGlobalMsg", "正在启动上号器"));

			const { orderInfo = {} } = await getOnProcessGame(); //回调函数获取最新值只能ref（需要和state建立联系）或者http

			const { isMemberPlay, isNetbarPlay, productId, buyPId, id } = orderInfo;

			let data = {
				hours,
			};
			let path = "game_launch";

			if (isMemberPlay || isNetbarPlay) {
				path = "vip_game_launch";
				data = {
					...data,
					product_id: productId,
				};

				if (isNetbarPlay) {
					const { Id: NetBarId } = window.mbQuery?.netbarJson?.Netbar || {};

					data = {
						...data,
						status: 0,
						NetBarId,
						guid: window.mbQuery?.netbarJson?.guid,
					};
				}
			} else {
				//兼容游戏记录上号
				data = {
					...data,
					id: buyPId ? buyPId / 1 : id / 1,
				};
			}

			const req = new Request({
				url: `/api/user/v1/${path}`,
				method: "post",
				source: 2,
				headers: {
					token: _state.token,
				},
				data,
			});

			const res = await req.send();

			if (res.base.code !== "200") {
				throw new Error(res.base?.msg || "启动游戏失败，请联系客服");
			}

			if (isMemberPlay || isNetbarPlay) {
				//大会员和网吧上号获取接口返回的订单号
				const data = {
					...orderInfo,
					orderSn: res.data?.out_order_sn,
					person: res.data?.person, //ok为大会员上号，因为网吧上号后端也可能是走的大会员逻辑
				};

				setOnProcessGame({
					orderInfo: data,
				});

				orderAndStart(data);
			} else {
				orderAndStart(orderInfo);
			}
		} catch (error) {
			_dispatch(creator("setGlobalMsg", ""));

			sysMsg({
				msg: catchErrorHandle(error),
			});
		}
	};

	const startStepClose = async () => {
		_dispatch(creator("setStartStepIsShow", false));

		const { isOnline } = await getOnProcessGame();

		//上号成功后关闭弹窗不执行退出游戏
		if (!isOnline) {
			exitGame();
		}
	};

	const codeConvertClose = () => {
		_dispatch(creator("setCodeConvertIsShow", false));
	};

	const actShadowClose = () => {
		_dispatch(creator("setActShadowIsShow", false));
	};

	const kfClose = () => {
		_dispatch(creator("setKfIsShow", false));
	};

	const actModalClose = () => {
		_dispatch(creator("setActModalIsShow", false));
	};

	return (
		<>
			<div className="header">
				<img
					className="logo"
					src={isNetbar ? barLogo : logo}
					alt="logo"
					onClick={() => {
						openBrowser("http://www.wanjiayizhan.com");
					}}
				/>
				<button
					type="button"
					className={`back-btn ${canBack ? "active" : "disabled"}`}
					disabled={!canBack}
					onClick={() => {
						navigate(-1);
					}}
				></button>
				<button
					type="button"
					className="refresh-btn"
					onClick={() => {
						window.location.reload();
					}}
				></button>
				<div className="nav">
					{NavList.map((ele) => (
						<NavLink
							key={ele.key}
							to={ele.to}
							className={({ isActive }) =>
								`nav-btn${isActive ? " active" : ""}`
							}
						>
							{ele.name}
						</NavLink>
					))}
				</div>
				{/* <button
					type="button"
					className="kf-btn"
					onClick={() => {
						_dispatch(creator("setKfIsShow", true));
					}}
					style={{ visibility: "hidden" }}
				></button> */}
				<img
					src={qqKfIcon}
					alt=""
					style={{
						width: 161,
						marginLeft: 20,
					}}
				/>
				<div style={{ marginLeft: 10 }}>
					<SearchBox placeholder="搜索游戏/商品名称" />
				</div>
				<div
					className="head-img"
					onMouseEnter={() => {
						_state.token && setMenuIsShow(true);
					}}
					onMouseLeave={() => {
						_state.token && setMenuIsShow(false);
					}}
					onClick={() => {
						checkLogin(_state, _dispatch, () => {});
					}}
				>
					<div className={menuIsShow ? " active" : ""}>
						<div className="img"></div>
						<div className="username">
							{_state.userInfo?.nickname ||
								_state.userInfo?.phone ||
								window.mbQuery?.netbarInfo?.Name ||
								"会员用户"}
						</div>
						<div className="userid">ID:{_state.userInfo?.id}</div>
						<div className="vipinfo">
							{memberTime > 0 ? (
								<div>
									<img src={crown} alt="" />
									<span>
										VIP剩
										{memberTime / 60 / 24 < 1
											? `${parseInt(memberTime / 60)}小时${
													memberTime % 60 ? `${memberTime % 60}分钟` : ""
											  }`
											: `${(memberTime / 60 / 24).toFixed(0)}天`}
									</span>
								</div>
							) : (
								<button
									type="button"
									onClick={(e) => {
										checkLogin(_state, _dispatch, () => {
											_dispatch(creator("setMemberPayIsShow", true));
										});

										e.stopPropagation();
									}}
								>
									购买大会员
								</button>
							)}
						</div>
						<div className={`menu${memberTime > 0 ? " vip-menu" : ""}`}>
							{memberTime > 0 && (
								<div
									className="renew-btn"
									onClick={(e) => {
										checkLogin(_state, _dispatch, () => {
											_dispatch(creator("setMemberPayIsShow", true));
										});

										e.stopPropagation();
									}}
								>
									<div></div>
									<div>续费会员</div>
								</div>
							)}

							<div
								className="my-game-btn"
								onClick={(e) => {
									navigate("/Personal/0");

									e.stopPropagation();
								}}
							>
								<div></div>
								<div>我的游戏</div>
							</div>
							<div
								className="my-order-btn"
								onClick={(e) => {
									navigate("/Personal/1");

									e.stopPropagation();
								}}
							>
								<div></div>
								<div>我的订单</div>
							</div>
							<div
								className="code-convert-btn"
								onClick={(e) => {
									checkLogin(_state, _dispatch, () => {
										_dispatch(
											creator("setCodeConvertIsShow", {
												isShow: true,
											})
										);
									});

									e.stopPropagation();
								}}
							>
								<div></div>
								<div>口令兑换</div>
							</div>
							<div
								className="logout-btn"
								onClick={(e) => {
									logOut(_dispatch);
									setMenuIsShow(false);

									e.stopPropagation();
								}}
							>
								<div></div>
								<div>退出登录</div>
							</div>
						</div>
					</div>
				</div>
				{/* <button type="button" className="kf-btn"></button> */}
				<button
					type="button"
					className="minimize-btn"
					onClick={() => {
						window.mbQuery?.minimize?.();
					}}
				></button>
				<button
					type="button"
					className="close-btn"
					onClick={() => {
						if (closeTips === undefined) {
							setBeforeCloseIsShow(true);
						} else if (closeTips === 0) {
							window.mbQuery?.hide?.();
						} else if (closeTips === 1) {
							window.mbQuery?.close?.();
						}
					}}
				></button>
			</div>
			<div className={`global-msg${_state.globalMsg ? " active" : ""}`}>
				{_state.globalMsg}
			</div>
			<Outlet />
			<Login isShow={_state.loginIsShow} onClose={loginClose} />
			<MemberPay isShow={_state.memberPayIsShow} onClose={memberPayClose} />
			<BeforeClose isShow={beforeCloseIsShow} onClose={beforeCloseClose} />
			<SelectTime
				isShow={_state.selectTimeIsShow?.isShow}
				playType={_state.selectTimeIsShow?.playType}
				useAble={_state.selectTimeIsShow?.useAble}
				onClose={selectTimeClose}
				onOk={(hours) => {
					selectTimeOk(hours);
				}}
			/>
			<StartStep isShow={_state.startStepIsShow} onClose={startStepClose} />
			<CodeConvert
				isShow={_state.codeConvertIsShow}
				onClose={codeConvertClose}
			/>
			<ActShadow
				isShow={_state.actShadowIsShow}
				onClose={actShadowClose}
				onOk={() => {
					checkLogin(_state, _dispatch, () => {});
				}}
			/>
			<UpdateProcess
				isShow={_state.updateProcessIsShow?.isShow}
				percent={_state.updateProcessIsShow?.percent}
			/>
			<Kf isShow={_state.kfIsShow} onClose={kfClose} />
			<ActModal isShow={_state.actModalIsShow} onClose={actModalClose} />
		</>
	);
}
